import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-scout',
  templateUrl: './scout.component.html',
  styleUrls: ['./scout.component.scss']
})
export class ScoutComponent {
  constructor(private dialogRef: MatDialogRef<ScoutComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
